import * as React from 'react'

import { Alert, Box, Button, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { EsignatureRequest } from 'modules/esignatures/hooks/requests/useGetEsignatureRequests'

interface Props {
  saving: boolean
  disabledButton: boolean
  onSubmit: () => void
  onClose: () => void
  signatureRequests: EsignatureRequest[]
}

const FillableModal = ({ saving, disabledButton, onSubmit, onClose, signatureRequests }: Props) => {
  const actionsDisabled = saving || disabledButton
  const description = saving
    ? i18n.t('documents.modal.fillable.modal.loading')
    : i18n.t('documents.modal.fillable.modal.description')

  return (
    <Modal
      locked={actionsDisabled}
      illustration="alert"
      title={i18n.t('documents.modal.fillable.modal.title')}
      description={description}
      onClose={actionsDisabled ? () => null : onClose}
      onSubmit={actionsDisabled ? () => null : onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose} disabled={disabledButton}>
            {i18n.t('documents.modal.fillable.modal.back')}
          </Button>
          <Button submit disabled={actionsDisabled} loading={disabledButton}>
            {i18n.t('documents.modal.fillable.modal.confirm')}
          </Button>
        </>
      }
    >
      {saving && (
        <Box padding="s12" width="full" alignItems="center">
          <Spinner />
        </Box>
      )}
      {!saving && signatureRequests.length > 0 && (
        <Alert color="warning">
          {i18n.t('documents.modal.fillable.modal.esignatures_description')}
        </Alert>
      )}
    </Modal>
  )
}

export default observer(FillableModal)
